/*
 * @Author       : gentlelts@163.com
 * @Date         : 2020-09-16 17:34:02
 * @LastEditors  : lts
 * @LastEditTime : 2020-10-29 16:04:13
 * @FilePath     : \belle\src\app\main\loginSingle\index.js
 */
import angular from 'angular'
import { loginSingle } from 'redevConfig'

const enterPage = (loginSingle && loginSingle.page) || ''

const loginSinglePage = enterPage ? require(`redevelopment/main/loginSingle/${enterPage.templateName}`) : require('./views/loginSingle.html')
const loginSingleCtrl = enterPage ? require(`redevelopment/main/loginSingle/${enterPage.controllerName}`) : require('./loginSingleCtrl')


export default angular
    .module('app.loginSingle', [])
    .config(['$stateProvider', function config ($stateProvider) {
        $stateProvider.state('loginSingle', {
            url: '/belleSsoLogin',
            template: loginSinglePage,
            controller: 'loginSingleCtrl',
            title: 'E税云单点跳转loading',
        })
    }])
    .controller('loginSingleCtrl', loginSingleCtrl.default)
    .name



// WEBPACK FOOTER //
// ./src/app/main/loginSingle/index.js